import React from "react";
import { useFormContext, Controller } from "react-hook-form";
import FormErrorMessage from "Components/Shared/FormComponents/FormErrorMessage/FormErrorMessage";
import { DPReactSelect } from "Components/DP/DPReactSelect/DPReactSelect";
import { REWARD_REASONS } from "Shared/Constants/Constants";
import { FormField } from "Components/Shared/FormComponents/FormField/FormField";
import { CreateRewardFormFields } from "Components/Pages/UserProfile/UserProfile/UserProfileTabs/RewardsTab/CreateRewardForm/CreateRewardForm";

export const ReasonSelect = () => {
  const fieldName = "reason";
  const { errors } = useFormContext<CreateRewardFormFields>();

  return (
    <FormField fieldName="Reason for Reward">
      <Controller
        name={fieldName}
        defaultValue={null}
        rules={{ required: true }}
        as={DPReactSelect}
        options={REWARD_REASONS}
      />
      <FormErrorMessage
        showError={!!errors.reason}
        labelFor={fieldName}
        message="Please select a reason"
      />
    </FormField>
  );
};
